// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".market-info[data-v-3c1945f8]{flex-grow:1}.market-info__container[data-v-3c1945f8]{display:flex;flex-direction:column;grid-row-gap:1.5rem;row-gap:1.5rem}@media(min-width:992px){.market-info__container[data-v-3c1945f8]{grid-row-gap:1.75rem;row-gap:1.75rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
